var $53e95c7b6521e26c$exports = {};
$53e95c7b6521e26c$exports = {
    "Clear search": `Limpar pesquisa`
};


export {$53e95c7b6521e26c$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
